const query = (id, isPreview) => `
{
    imageWithTextWrapper(id: "${id}", preview: ${isPreview}) {
      variant
    textContentWrapperCollection {
        items {
          title
          shortDescription
          content
          variant
          badgeHeading
          badgeContent
        }
      }
      imageTextWarpperCollection(limit: 1) {
        items {
          heading
          description
          isReversed
          elementId
          showBackground
          variant
          categoryLinksCollection {
            items {
              name
              url
              label
              title
              target
              scrollToElementId
              imageType
              gaEventClass
              gaEventLabel
              ariaLabel
            }
          }
          images {
            internalTitle
            altText
            imageDesktop {
              title
              description
              url
              width
                height
            }
            imageMobile {
              title
              description
              url
              width
                height
            }
            bgDesktop {
              title
              description
              url
              width
                height
            }
            bgMobile {
              title
              description
              url
              width
                height
            }
          }
          backgroundImage {
            title
            description
            url
            width
            height
          }
          link {
            label
            title
            url
            target
            scrollToElementId
            gaEventClass
            gaEventLabel
            image {
              title
              description
              url
              width
              height
            }
          }
          video {
            title
            variant
            youtubeVideoId
            posterImage {
              altText
              imageDesktop {
                title
                description
                url
                width
                height
              }
              imageMobile {
                title
                description
                url
                width
                height
              }
            }
            isModal
            isButtonBlack
          }
        }
      }
      linkWrapperCollection{
        items{
           label
                title
                url
                target
                scrollToElementId
                gaEventClass
                gaEventLabel
                image {
                  title
                  description
                  url
                  width
                  height
                }
        }
      }
  }
}

`
module.exports = { query }
